<template>
  <modal :modal-key="'resubscribe_with_pin'" class="modal--welcomeback modal--zero-balance " @close="$emit('close')">
    <template slot="header">
      <h1> {{ getTranslations.home_modals_profile_email_thank_you_thank_you }} </h1>
      <img class="pinicon mt-1" src="static/images/email_submit_thankyou.svg" alt="">
    </template>
    <template slot="body">
      <p class="mt-3 mb-lg-4">{{ getTranslations.home_modals_profile_email_thank_you_a_verification }}
      </p>

    </template>
  </modal>
</template>

<script>
import Modal from '@/components/home/modals/shared/GenericModal';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'email-thank-you',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslationByOperator',
      'getTranslations',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/profile/EmailThankYou.vue